import Section from "../Section";

export default class NavBanner extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

  }
}
